import { useContext } from 'react';
import {
    TasksAndAlertsHourlyActivityContext,
    TasksAndAlertsHourlyActivityContextData
} from './context';

export function useTasksAndAlertsHourlyActivity(): TasksAndAlertsHourlyActivityContextData {
    const data = useContext<
        TasksAndAlertsHourlyActivityContextData | undefined
    >(TasksAndAlertsHourlyActivityContext);

    if (!data) {
        throw new Error(
            "TasksAndAlertsHourlyActivityContext unavailable. Are you sure you're using this in a nested component of an TasksAndAlertsHourlyActivityProvider?"
        );
    }

    return data;
}
